export const WATER_BEVERAGE_NAME = "Water (Flat/Sparkling)"
